<template>
  <div class="c-dialog-list">
    <div v-for="dialog in dialogs">
      <base-dialog
        v-if="dialog.isOpen"
        :messageText="dialog.messageText"
        :confirmText="dialog.confirmText"
        :cancelText="dialog.cancelText"
        @cancel="dialog.isOpen = false"
        @confirm="onClickConfirm(dialog)"
      ></base-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dialog-list',

  computed: {
    dialogs: {
      get() {
        return this.$store.state.dialogs;
      },

      set(value) {
        this.$store.commit('setDialogs', value);
      },
    },
  },

  methods: {
    onClickConfirm(dialog) {
      dialog.confirm();
      dialog.isOpen = false;
    },
  },
};
</script>
